export default {
    data() {
        return {
            idInputDisable: false,
            nameInputDisable: false,
            // keywordId:'',
            keywordType: '',
            keywordName: '',
            tableData: [],
            headers: {
                "Content-Type": "multipart/form-data"
            },
            // 控制对话显示
            dialogTableVisible: false,
            formLabelWidth: "120px",
            dialogTableVisible2: false,

            currentPage: 1,
            totalPage: 1,
            offset: '0',
            resourceLength: 15,

            formLabelWidth: "120px",
            // 要更改的图片的必须信息
            updateImg: {
                id: '',
                name: '',
                data: ''
            },
            //上传后返回的唯一文件名字
            fileName: '',
            // 上传图片的接口地址
            addresss: this.baseUrl + 'file/upload_img?token=' + this.$store.state.authority_management,
            // 上传图片的src地址显示上传的图片出来
            dialogImageUrl: '',
            // 是否显示上传的图片
            dialogVisible: false,
            //自己填写的图片名称
            imageName: '',
            //填写修改图片名称
            updateImageName: '',
            //修改图片名称的弹出框
            dialogUpdateImgVisible: false,

            // 轮播图图片服务器地址
            imgUrl: this.imgUrl,
            // 图片名称
            imgName: ''
        }
    },
    methods: {
        // 上传图片
        httpreq(q) {
            this.$upload(this.addresss, q).then(res => {
                this.fileName = res.data.result
            })
        },
        // 修改图片
        httpreq1(q) {
            this.$upload(this.addresss, q).then(res => {
                this.updateImg.data = res.data.result
                this.imgName = ''
            })
        },
        // 确定修改图片名称
        confirmUpdateImg() {
            this.dialogUpdateImgVisible = false
            let data = {
                token: this.$store.state.authority_management,
                name: this.updateImg.name,
                id: this.updateImg.id,
                type: '5',
                data: this.updateImg.data
            };
            // console.log('修改图片的数据为')
            // console.log(data)
            this.$post('resources/shop_edit', data).then(res => {
                // console.log('修改图片后返回的数据为')
                // console.log(res)
                if (res.data.status == 'success') {
                    this.$message({
                        showClose: true,
                        message: '更改成功',
                        type: 'success'
                    });
                    this.getData();
                    this.dialogdoc = false;
                    this.updateImg = {
                        id: '',
                        name: '',
                        data: '',
                    }
                    this.$refs['upload'].clearFiles()
                } else {
                    this.$message({
                        showClose: true,
                        message: '更改图片名失败',
                        type: 'error'
                    });
                }
            })
        },
        // 修改图片资源名字
        handleUpdate(obj) {
            // console.log(obj);
            this.dialogUpdateImgVisible = true;
            this.updateImg.id = obj.row.id;
            this.updateImg.data = obj.row.data;
            this.updateImg.name = obj.row.name;

            this.imgName = this.updateImg.data

        },
        onSearch() {
            this.currentPage = 1
            let data = {
                token: this.$store.state.authority_management,
                id: this.keywordId,
                name: this.keywordName,
                offset: 0,
                length: 999,
                type: 5
            };
            // 这里调用搜索资源接口
            this.$post('resources/shop_search', data).then(res => {
                // console.log(res)
                this.tableData = res.data.result.data
                this.totalPage = res.data.result.total
                // console.log(this.tableData)
                // alert("资源序号:" + tableData[0].id + "，资源名称:" + tableData[0].name + "，资源类型:" + tableData[0].type + "，试题")
            })
        },
        oncli(dataa) {
            // alert(dataa);
        },
        onSubmit() {
            // 这里调用提交修改的接口
            // this.$post(url, data).then(res => {
            //   console.log(res);
            // });
            // this.dialogTableVisible = false;
        },
        onReset(formName) {
            // 这里是清空修改中的内容 不用管
            this.dialogTableVisible = false;
            this.$refs[formName].resetFields();
        },
        hendelDelete(id) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.confirmDelete(id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        confirmDelete(id) {
            let data = { token: this.$store.state.authority_management, id: id };
            this.$post('resources/delete', data).then(res => {
                // console.log(res.data.status);
                if (res.data.status == 'success') {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getData();
                } else {
                    this.$message({
                        type: 'danger',
                        message: '删除失败!'
                    });
                }

            });
        },


        //改变分页的页数
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.resourceLength = val;
            this.getData();
        },
        //点击分页跳转
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.offset = (val - 1) * this.resourceLength;
            this.getData();
        },

        handleRemove(file, fileList) {
            // console.log(file, fileList);
        },
        exceed() {
            alert('只能上传一张图片')
            this.$message()
        },
        handlePictureCardPreview(file) {
            // console.log(file)
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        //图片成功上传到服务器
        handleSuccess(response, file, fileList) {
            // 上传成发生的事件
            // console.log('图片上传成功')
            // console.log(response);
            // console.log(file);
            // console.log(fileList);
            this.fileName = response.result
            // if (response.status == 'success') {
            // alert('上传图片成功了');
            // this.dialogTableVisible = false;
            // }
        },
        //确定添加图片资源到数据库
        addImageSourse() {
            if (this.imageName == '') {
                this.$message({
                    showClose: true,
                    type: 'error',
                    message: '图片名不能为空'
                });
                return false;
            }
            // else if (this.dialogImageUrl == '') {
            //   this.$message({
            //     showClose: true,
            //     type: 'error',
            //     message: '请上传一张图片'
            //   });
            //   return false;
            // }
            this.$post('resources/shop_create', {
                token: this.$store.state.authority_management,
                name: this.imageName,
                data: this.fileName,
                type: '5'
            }).then(res => {
                // console.log(res)
                if (res.data.status == 'success') {
                    this.$message({
                        showClose: true,
                        message: '添加图片资源成功',
                        type: 'success'
                    });
                    this.clearFil();
                    this.getData();
                    this.dialogTableVisible = false;
                    this.imageName = '';
                    this.dialogImageUrl = '';
                    this.dialogVisible = false;
                } else {
                    this.$message({
                        showClose: true,
                        message: '添加图片资源失败',
                        type: 'error'
                    });
                }

            })
        },
        beforeUpload(file) {
            // console.log(file);
            const isImage = file.name.replace(/.+\./, "");
            if (['jpg', 'jpeg', 'png', 'JPG', 'JPEG'].indexOf(isImage) == '-1') {
                // console.log('进入判断')
                this.$message({
                    showClose: true,
                    message: '上传文件类型错误！',
                    type: 'warning'
                })
                return false
            }
        },
        handleChange(file, fileList) {
            this.fileList = fileList;
        },
        getData() {
            // 获取数据
            let data = { 
                token: this.$store.state.authority_management,
                type: 5,
                offset: this.offset,
                length: this.resourceLength,
                name: this.keywordName
            };
            this.$post('resources/shop_search', data).then(res => {
                this.tableData = res.data.result.data;
                this.totalPage = res.data.result.total;
            })
        },
        clearFil() {
            this.$refs['my-upload'].clearFiles();
        },
        // 编辑弹窗上传图片成功后调用的方法
        handleUploadSuccess(response, file) {
            // 修改弹窗的图片修改成功后, 将原来的图片隐藏, 显示上传成功后的图片
            this.updateImg.data = response.result
            this.imgName = ''
        },
        // 取消更新图片
        closeUpdateImg() {
            this.dialogUpdateImgVisible = false
            this.$refs['upload'].clearFiles()
        }
    },
    created() {
        this.getData();
    }
}